import React from 'react';
import {positions, Provider} from "react-alert";
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import Home from './pages';
import SignIn from './pages/SignIn';
import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';
import ForgotPassword from "./pages/ForgotPassword";
import PasswordRecovery from "./pages/PasswordRecovery";
import AlertTemplate from 'react-alert-template-basic';
import LoadingProvider from './components/Loading/Loading.provider';
import queryString from 'query-string';
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import SelectFarm from "./pages/SelectFarm";
import SelectCategory from "./pages/SelectCategory";
import ForgotPasswordAppWeb from "./pages/ForgotPasswordAppWeb";
import PasswordRecoveryAppWeb from "./pages/PasswordRecoveryAppWeb";
import Logout from './pages/Logout';
import SelectFarmStore from './pages/SelectFarmStore';
import SignUp from './pages/SignUp';
import ConfirmSignUp from './pages/ConfirmSignUp';
import ForgotPasswordStore from './pages/ForgotPasswordStore';
import PasswordRecoveryStore from './pages/PasswordRecoveryStore';
import SignInAppWeb from "./pages/AuthWeb/SignInAppWeb";
import SignInAppStore from './pages/AuthStore/SignInAppStore';

Amplify.configure(awsconfig);

const App = () => {

    const search = queryString.parse(window.location.search);
    console.log("🚀 ~ file: App.js:36 ~ App ~ search:", search)
    let routesAdm;
    let routes;
    let ambImilk = false;
    let ambStore = false;
    let ambAppWeb = false;

    if (search && search.adm) {
        ambImilk = true;
        routesAdm = [
            <Route path="/login" exact component={SignIn} />,
            <Route path="/esqueci-minha-senha" component={ForgotPassword} />,
            <Route path="/recuperar-senha" component={PasswordRecovery} />,
            <Route path="/" exact component={Home}/>,
        ];
    } else if (search && search.store) {
        ambStore = true;
        routes = [
            <Route path="/login" exact component={SignInAppStore} />,
            <PrivateRoute path="/selecionar-categoria" component={SelectCategory} />,
            <Route path="/recuperar-senha" exact component={PasswordRecoveryStore} />,
            <Route path="/esqueci-minha-senha" exact component={ForgotPasswordStore} />,
            <PrivateRoute path="/selecionar-fazenda" exact component={SelectFarmStore} />,    
            <Route path="/cadastre-se" exact component={SignUp} />,                          
            <Route path="/confirmar" exact component={ConfirmSignUp} />,                          
            <Route path="/" exact component={SignInAppStore}/>,
        ];
    } else {
        ambAppWeb = true;
        routes = [
            <Route path="/login" exact component={SignInAppWeb} />,
            <PrivateRoute path="/selecionar-categoria" component={SelectCategory} />,
            <Route path="/recuperar-senha-app-web" exact component={PasswordRecoveryAppWeb} />,
            <Route path="/esqueci-minha-senha-app-web" exact component={ForgotPasswordAppWeb} />,
            <PrivateRoute path="/selecionar-fazenda" exact component={SelectFarm} />       ,                             
            <Route path="/" exact component={SignInAppWeb}/>,
        ];
    }

    return (
        <>
            <LoadingProvider isImilk={ambImilk} isStore={ambStore} isAppWeb={ambAppWeb} >
                <Provider template={AlertTemplate} position={positions.MIDDLE}>
                    <BrowserRouter>
                        <Switch>
                            <Route path="/logout" exact component={Logout} />
                            {routesAdm}
                            {routes}
                        </Switch>
                    </BrowserRouter>
                </Provider>
            </LoadingProvider>
        </>
    )
};

export default App;
